import { Models } from '@rematch/core';
import { auth } from './auth.ts';
import { user } from './user.ts';
import { demo } from './demo.ts';

export interface RootModel extends Models<RootModel> {
  auth: typeof auth;
  user: typeof user;
  demo: typeof demo;
}

export const models: RootModel = { auth, user, demo };
